import { render, staticRenderFns } from "./BoardNotFound.vue?vue&type=template&id=3ae813ce&scoped=true&"
import script from "./BoardNotFound.vue?vue&type=script&lang=js&"
export * from "./BoardNotFound.vue?vue&type=script&lang=js&"
import style0 from "./BoardNotFound.vue?vue&type=style&index=0&id=3ae813ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ae813ce",
  null
  
)

export default component.exports